import { Card, Input } from '@platform/design-system';
import type { ReactNode } from 'react';
import { usePageContext } from '../usePageContext.ts';
import {
  FIELD_GROUPS,
  FIELD_UNITS,
  FIELDS_WITH_HELP,
  type FieldGroup,
  type FieldUnit,
} from './calculator-fields.ts';
import { fieldIssueOf, type CalculatorField, type CalculatorInput } from './profitability.ts';
import styles from './Calculator.module.css';

export type CalculatorInputsProps = {
  input: CalculatorInput;
  currency: string;
  onChange: (field: CalculatorField, value: string) => void;
  extras: Partial<Record<FieldGroup['id'], ReactNode>>;
};

export const CalculatorInputs = ({ input, currency, onChange, extras }: CalculatorInputsProps) => {
  const { t } = usePageContext();
  const suffixes: Readonly<Record<FieldUnit, string>> = {
    money: currency,
    count: t('calculator.units'),
    percent: '%',
  };
  return (
    <div className={styles['inputs']}>
      {FIELD_GROUPS.map((group) => (
        <Card key={group.id} title={t(`calculator.group_${group.id}`)}>
          <p className={styles['muted']}>{t(`calculator.group_${group.id}Help`)}</p>
          {extras[group.id]}
          <div className={styles['fields']}>
            {group.fields.map((field) => {
              const issue = fieldIssueOf(field, input[field]);
              return (
                <Input
                  key={field}
                  label={t(`calculator.field_${field}`)}
                  inputMode="decimal"
                  autoComplete="off"
                  suffix={suffixes[FIELD_UNITS[field]]}
                  value={input[field]}
                  helperText={
                    FIELDS_WITH_HELP.includes(field) ? t(`calculator.field_${field}Help`) : undefined
                  }
                  errorText={issue === null ? undefined : t(`calculator.issue_${issue}`)}
                  onChange={(event) => {
                    onChange(field, event.target.value);
                  }}
                />
              );
            })}
          </div>
        </Card>
      ))}
    </div>
  );
};
